import React, { useState } from 'react';
import { Tabs } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';

import { tabs } from '../utils/tabs';
import { Page } from '../../../../../shared/ui/Page';
import { ShopDetailTabKey } from '../service/shop-details.interface';

export const ShopDetailsEditPage = () => {
    const [tab, setTab] = useState<ShopDetailTabKey>();
    const navigate = useNavigate();

    const changeTab = (key: ShopDetailTabKey) => {
        navigate(key, {
            replace: true,
        });
    };

    return (
        <Page isBackButton title={'Редактирование магазина'}>
            <Tabs
                activeKey={tab}
                onChange={key => changeTab(key)}
                items={tabs}
            />
            <Outlet />
        </Page>
    );
};
